module.exports = __webpack_public_path__ + "static/media/Phillip.7faf7396.jpg";